import PortOpeningRule from '../../../models/entities/PortOpeningRuleOnPrem';
import { PortOpeningRequestsDirection } from '../../../models/enums/POR/PortOpeningRequestsDirection';

export type PORColumn = {
	header: string;
	cell: (rule: PortOpeningRule) => string;
	limit?: number;
};

export const RuleColumnsLayout = new Map<PortOpeningRequestsDirection, PORColumn[]>();

RuleColumnsLayout.set(PortOpeningRequestsDirection.DomainToConnection, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRule) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRule) => rule.name,
		limit: 40,
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRule) => rule.action?.name,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRule) => rule.sourceIPs,
		limit: 15,
	},
	{
		header: 'Dest. URLs',
		cell: (rule: PortOpeningRule) => rule.destinationURLs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRule) => rule.destinationIPs,
		limit: 15,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRule) => rule.destinationPorts,
	},
	{
		header: 'Protocol',
		cell: (rule: PortOpeningRule) => rule.protocol,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRule) => rule.description,
		limit: 20,
	},
]);

RuleColumnsLayout.set(PortOpeningRequestsDirection.DomainToInternet, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRule) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRule) => rule.name,
		limit: 20,
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRule) => rule.action?.name,
	},
	{
		header: 'Source IPs',
		cell: (rule: PortOpeningRule) => rule.sourceIPs,
		limit: 15,
	},
	{
		header: 'Dest. URLs',
		cell: (rule: PortOpeningRule) => rule.destinationURLs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRule) => rule.destinationIPs,
		limit: 15,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRule) => rule.destinationPorts,
	},
	{
		header: 'Description',
		cell: (rule: PortOpeningRule) => rule.description,
		limit: 20,
	},
]);

RuleColumnsLayout.set(PortOpeningRequestsDirection.DomainProxyToInternet, [
	{
		header: 'Operation',
		cell: (rule: PortOpeningRule) => rule.operation?.name,
	},
	{
		header: 'Name',
		cell: (rule: PortOpeningRule) => rule.name,
		limit: 40,
	},
	{
		header: 'Action',
		cell: (rule: PortOpeningRule) => rule.action?.name,
	},
	{
		header: 'Dest. URLs',
		cell: (rule: PortOpeningRule) => rule.destinationURLs,
		limit: 15,
	},
	{
		header: 'Dest. IPs',
		cell: (rule: PortOpeningRule) => rule.destinationIPs,
		limit: 15,
	},
	{
		header: 'Ports',
		cell: (rule: PortOpeningRule) => rule.destinationPorts,
	},
	{
		header: 'SSL Bypass',
		cell: (rule: PortOpeningRule) => rule.sslBypass ? 'Yes' : 'No',
		limit: 3,
	},
]);